// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
// PROD File

export const environment = {
  baseUrl: 'https://www.empleosperu.gob.pe/usermanagement',
  baseCUL: 'https://www.empleosperu.gob.pe/CertificadoUnicoLaboral/',
  baseDirectorio: 'http://192.168.18.195:8480/DirectorioIndependiente/#/registro-independiente',
  baseDirectorioBusqueda: 'http://192.168.18.195:8480/DirectorioIndependiente/#/buscar-servicios',
  sidBaseUrl: 'www.empleosperu.gob.pe/oauth',
  basePortal: 'https://www.empleosperu.gob.pe/portal-mtpe/#/',
  base: 'https://www.empleosperu.gob.pe/',
  baseIVR: 'https://www.empleosperu.gob.pe/registroindependiente/',
  baseOauth: 'https://www.empleosperu.gob.pe/oauth',
  baseUriWccSearchJob: 'https://mtpe-candidatos.empleosperu.gob.pe/my-applications',
  baseWcc: 'https://mtpe-candidatos.empleosperu.gob.pe',
  clientId: 'portal-mtpe',
  baseEmpresa: 'https://mtpe-empleadores.empleosperu.gob.pe/',
  baseOrientadores: 'http://mtpe-orientadores.empleosperu.gob.pe/',
  baseCRM: 'http://192.168.171.96/crm-mtpe/#/',
  production: false
};

  /*
   * For easier debugging in development mode, you can import the following file
   * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
   *
   * This import should be commented out in production mode because it will have a negative impact
   * on performance if an error is thrown.
   */
  // import 'zone.js/dist/zone-error';  // Included with Angular CLI.

